import small from './public/examples/600x600/4-v2-320.webp';
import large from './public/examples/600x600/4-v2-600.webp';

export default {
    src: large,
    srcSet: `${small} 320w, ${large} 600w`,
    sizes: '(max-width: 991px) 45vw, 480px',
};
